<template>
  <layout>
    <div class="section">
      <div style="width: 1200px; margin: 0 auto">
        <!-- 步骤条 -->
        <div class="cc-step">
          <div class="step-warrp">
            <div class="step-header-warrp">
              <div
                :class="['step-item', { active: step >= item.id }]"
                v-for="item in stepList"
                :key="item.id"
              >
                <span>0{{ item.id }} {{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 确认订单 -->
        <div v-if="step === 1">
          <template v-if="registerList.length > 0 || renewList.length > 0 || transferList.length > 0 ">
            <div style="margin: 30px 0" v-if="registerList.length > 0">
              <!-- 域名注册清单 -->
              <div class="table-title">域名注册清单</div>
              <Table
                ref="registerTable"
                class="cc-table"
                :columns="columns"
                :data="registerList"
                :loading="registerLoading"
                @on-selection-change="select"
              >
                <!-- 年限选择 -->
                <template slot="year" slot-scope="{ row, index }">
                  <Select
                    transfer
                    :value="row.count"
                    style="width: 120px"
                    @on-change="itemYearChange($event, index, 0)"
                  >
                    <Option
                      v-for="item2 in yearList"
                      :key="item2.value"
                      :value="item2.value"
                      >{{ item2.label }}</Option
                    >
                  </Select>
                </template>
                <!-- 价格显示 -->
                <template slot="price" slot-scope="{ row }">
                  <span class="c-o1"
                    >{{
                      row.activityPrice != null ? row.activityPrice : row.price
                    }}<span>元/年</span></span
                  >
                  <span>
                    (续费价格:
                    <span class="c-o1"
                      >{{
                        row.renewActivityPrice != null
                          ? row.renewActivityPrice
                          : row.renewPrice
                      }}<span>元/年</span></span
                    >)</span
                  >
                </template>
                <!-- 年限显示 -->
                <template slot="total" slot-scope="{ row }">
                  <span class="c-o1">{{ row | priceFilter }}</span>
                </template>
                <!-- 操作 -->
                <template slot="action" slot-scope="{ row, index }">
                  <Button class="remove-btn" @click="del(0, row, index)"
                    >移除</Button
                  >
                </template>
              </Table>
            </div>
            <div style="margin: 30px 0" v-if="renewList.length > 0">
              <!-- 域名续费清单 -->
              <div class="table-title">域名续费清单</div>
              <Table
                ref="renewTable"
                class="cc-table"
                :columns="columns2"
                :data="renewList"
                :loading="renewLoading"
                @on-selection-change="select"
              >
                <!-- 年限选择 -->
                <template slot="year" slot-scope="{ row, index }">
                  <Select
                    transfer
                    :value="row.count"
                    style="width: 120px"
                    @on-change="itemYearChange($event, index, 1)"
                  >
                    <Option
                      v-for="item2 in yearList"
                      :key="item2.value"
                      :value="item2.value"
                      >{{ item2.label }}</Option
                    >
                  </Select>
                </template>
                <!-- 价格显示 -->
                <template slot="price" slot-scope="{ row }">
                  <span class="c-o1"
                    >{{
                      row.activityPrice != null ? row.activityPrice : row.price
                    }}<span>元/年</span></span
                  >
                </template>
                <!-- 年限显示 -->
                <template slot="total" slot-scope="{ row }">
                  <span class="c-o1">{{ row | priceFilter }}</span>
                </template>
                <!-- 操作 -->
                <template slot="action" slot-scope="{ row, index }">
                  <Button class="remove-btn" @click="del(1, row, index)"
                    >移除</Button
                  >
                </template>
              </Table>
            </div>
            <div style="margin: 30px 0" v-if="transferList.length > 0">
              <!-- 域名续费清单 -->
              <div class="table-title">域名转入清单</div>
              <Table
                  ref="transferTable"
                  class="cc-table"
                  :columns="columns3"
                  :data="transferList"
                  :loading="transferLoading"
                  @on-selection-change="select"
              >
                <!-- 价格显示 -->
                <template slot="price" slot-scope="{ row }">
                  <span class="c-o1"
                  >{{
                      row.activityPrice != null ? row.activityPrice : row.price
                    }}<span>元/年</span></span
                  >
                </template>
                <!-- 年限显示 -->
                <template slot="total" slot-scope="{ row }">
                  <span class="c-o1">{{ row | priceFilter }}</span>
                </template>
                <!-- 操作 -->
                <template slot="action" slot-scope="{ row, index }">
                  <Button class="remove-btn" @click="del(1, row, index)"
                  >移除</Button
                  >
                </template>
              </Table>
            </div>
            <!-- 实名信息 -->
            <div class="sm-info" v-if="registerList.length > 0 || transferList.length > 0">
              <h3 style="color: #333">
                注册局要求，域名购买时必须填写完整的用户信息方可注册。以下为您曾经使用过的域名信息，您可以直接使用：
              </h3>
              <div style="display: flex; margin: 20px 0">
                <h4
                  style="
                    color: #888888;
                    font-weight: 400;
                    margin-top: 10px;
                    margin-left: 10px;
                  "
                >
                  使用已实名的信息模板注册域名后不需要再提交实名，可在信息模板中创建和管理。
                </h4>
              </div>
              <div class="sm-table">
                <Table
                  class="template-table"
                  ref="templateTable"
                  :show-header="false"
                  :columns="templateColumns"
                  :data="templateData"
                  @on-select="evt_select"
                >
                  <template slot="name" slot-scope="{ row }">
                    <span v-if="row.type === 0">{{ row.locName }}(个人)</span>
                    <span v-else>{{ row.locBusinessName }}(企业)</span>
                  </template>
                  <template slot="action" slot-scope="{ row, index }">
                    <div style="display: flex; justify-content: space-between">
                      <Button
                        class="remove-btn"
                        @click="viewTemplate(row, index)"
                        >查看</Button
                      >
                      <Button
                        class="remove-btn"
                        v-if="row.isTemporary === 0"
                        @click="delTemplate(row, index)"
                        >删除</Button
                      >
                    </div>
                  </template>
                </Table>
                <page
                  :total="templatePage.total"
                  @onChange="onChange"
                  @onPageSizeChange="onPageSizeChange"
                />
              </div>
            </div>
            <!-- 交易面板 -->
            <div class="transaction-tool">
              <div style="padding-top: 20px">
                <div>
                  注册域名数量
                  <span style="color: #e8340b; font-weight: bold">{{
                    registerCount
                  }}</span>
                  个
                </div>
                <div>
                  续费域名数量
                  <span style="color: #e8340b; font-weight: bold">{{
                    renewCount
                  }}</span>
                  个
                </div>
                <div>
                  转入域名数量
                  <span style="color: #e8340b; font-weight: bold">{{
                      transferCount
                    }}</span>
                  个
                </div>
              </div>
              <div>
                <div class="info-tool">
                  <div>
                    总计：
                    <span class="c-o1" style="font-size: 18px">{{
                      totalPrice | priceToRadix
                    }}</span
                    >元
                  </div>
                  <Button class="buy-btn" @click="event_buy">立即购买</Button>
                </div>
                <div class="row">
                  <Checkbox class="c-check" v-model="single"
                    >我已阅读并同意遵守</Checkbox
                  >
                  <div
                    style="cursor: pointer; color: #f9521f"
                    @click="domainNameRegisterRulesModel"
                  >
                    《域见未来域名注册服务协议》
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template class="sm-info" v-else>
            <div
              style="margin: 30px 0; font-size: 18px; text-align: center"
              class="sm-info"
            >
              购物车空空如也，快去添加吧！
            </div>
          </template>
        </div>
        <!-- 在线支付 -->
        <div class="order-warp" v-if="step === 2" style="position: relative">
          <loading :loading="orderLoading" style="z-index: 11"></loading>
          <div class="order-title">订单详情</div>
          <Table :columns="orderColumns" :data="orderList">
            <template slot="action" slot-scope="{ row }">
              <Button @click="act_orderInfo(row)">订单详情</Button>
            </template>
          </Table>
          <div class="order-tool-title">请选择支付方式</div>
          <div class="order-tool" style="position: relative">
            <loading :loading="payLoading" style="z-index: 11"></loading>
<!--            <div
              :class="['item-tool', { active: orderStep === 1 }]"
              @click="payState(1)"
            >
              <img src="@/assets/image/ali-icon.png" />支付宝支付
            </div>-->
            <div
              :class="['item-tool item-tool-info', { active: orderStep === 2 }]"
              @click="payState(2)"
            >
              <div>余额支付：剩余￥{{ balance }}</div>
              <div
                class="tips"
                v-if="orderList.length > 0 && balance < orderList[0].payAmount"
              >
                余额已不足支付，<span @click.stop="toRecharge">充值</span>
              </div>
            </div>
          </div>
          <Button class="pay-btn" type="primary" @click="evt_pay"
            >立即支付</Button
          >
          <div class="pay-tips">
            温馨提示：由于域名的时效性，订单如未及时支付结算，有可能会出现结算失败。为避免造成损失，请及时支付
          </div>
        </div>
        <!-- 支付完成 -->
        <div class="order-result" v-if="step === 3">
          <div class="order-success">
            <div class="order-success-icon">
              <img src="@/assets/image/order-success-icon.png" />
            </div>
            <div>恭喜您，已支付成功！</div>
          </div>
          <Table
            :columns="resColumns"
            :data="resList"
            :show-header="false"
          ></Table>
        </div>
      </div>
    </div>
    <pay-modal :show.sync="wayModalShow" :codeUrl="wayPayCode"></pay-modal>
    <order-info-modal
      :show.sync="orderInfoModalShow"
      :id="orderId"
    ></order-info-modal>
    <!-- 域见未来域名注册协议 -->
    <rule-modal
      :show.sync="domainNameRegisterRulesModelShow"
      :content="domainNameRegisterRulesContent"
      :title="domainNameRegisterRulesTitle"
    ></rule-modal>
    <!-- 域见未来隐私声明 -->
    <rule-modal
      :show.sync="privacyStatementRulesModelShow"
      :content="privacyStatementRulesContent"
      :title="privacyStatementRulesTitle"
    ></rule-modal>
  </layout>
</template>
<script>
import layout from "./components/layout.vue";
import page from "components/page.vue";
import loading from "components/loading.vue";
import payModal from "./components/payModal.vue";
import orderInfoModal from "./components/orderInfoModal.vue";
import smTableExpand from "./components/smTableExpand.vue";
import ruleModal from "components/ruleModal.vue";
// import domainNameRegisterRules from "assets/rule/domainNameRegisterRules";
// import privacyStatement from "assets/rule/privacyStatement";
import {
  getTemplates,
  getShoppingCart,
  delectShopCart,
  createOrder,
  delectTemplates,
  pay,
  orderCountEdit,
  orderPayOrder,
  agreementList
} from "api/domain.js";
import { mapMutations, mapState, mapActions } from "vuex";
import { WEBSOCKET_URL } from "@/utils/config";
export default {
  components: {
    layout,
    page,
    loading,
    payModal,
    orderInfoModal,
    ruleModal,
  },
  filters: {
    priceFilter(val) {
      // 注册价格
      const registerPrice =
        val.activityPrice != null ? val.activityPrice : val.price;
      if (val.type === 0) {
        if (val.count !== 1) {
          // 超过一年使用续费价格
          let renewPrice =
            val.renewActivityPrice != null
              ? val.renewActivityPrice
              : val.renewPrice;
          const totalPrice = registerPrice + renewPrice * (val.count - 1);
          return `${totalPrice}元`;
        }
        return `${registerPrice}元`;
      }
      return `${registerPrice * val.count}元`;
    },
    priceToRadix(val) {
      return val.toFixed(2);
    },
  },
  data() {
    return {
      single: false,
      step: 1,
      stepList: [
        {
          id: 1,
          name: "确认订单",
        },
        {
          id: 2,
          name: "在线支付",
        },
        {
          id: 3,
          name: "支付成功",
        },
      ],
      // 确认订单数据
      yearList: [
        {
          value: 1,
          label: "1年",
        },
        {
          value: 2,
          label: "2年",
        },
        {
          value: 3,
          label: "3年",
        },
        {
          value: 4,
          label: "4年",
        },
        {
          value: 5,
          label: "5年",
        },
        {
          value: 6,
          label: "6年",
        },
        {
          value: 7,
          label: "7年",
        },
        {
          value: 8,
          label: "8年",
        },
        {
          value: 9,
          label: "9年",
        },
        {
          value: 10,
          label: "10年",
        },
      ],
      value: null,
      columns: [
        {
          type: "selection",
          width: 60,
        },
        {
          align: "center",
          title: "域名",
          key: "tradeName",
        },
        {
          slot: "year",
          renderHeader: (h) => {
            let that = this;
            let option = this.yearList.map((o) => {
              return h(
                "Option",
                {
                  props: {
                    value: o.value,
                  },
                },
                o.label
              );
            });
            let select = h(
              "Select",
              {
                props: {
                  transfer: true,
                  value: this.value,
                },
                style: {
                  width: "120px",
                },
                on: {
                  "on-change"(val) {
                    that.registerList.forEach((element) => {
                      element.count = val;
                    });
                    let ids = that.registerList.map(item => {
                      return item.id;
                    })
                    that.calculateAll(val, ids);
                  },
                },
              },
              option
            );
            return select;
          },
        },
        {
          align: "center",
          title: "单价",
          slot: "price",
        },
        {
          align: "center",
          title: "小计",
          slot: "total",
        },
        {
          align: "center",
          title: "操作",
          slot: "action",
        },
      ],
      columns2: [
        {
          type: "selection",
          width: 60,
        },
        {
          align: "center",
          title: "域名",
          key: "tradeName",
        },
        {
          slot: "year",
          renderHeader: (h) => {
            let that = this;
            let option = this.yearList.map((o) => {
              return h(
                "Option",
                {
                  props: {
                    value: o.value,
                  },
                },
                o.label
              );
            });
            let select = h(
              "Select",
              {
                props: {
                  transfer: true,
                  value: this.value,
                },
                style: {
                  width: "120px",
                },
                on: {
                  "on-change"(val) {
                    that.renewList.forEach((element) => {
                      element.count = val;
                    });
                    let ids = that.renewList.map(item => {
                      return item.id;
                    })
                    that.calculateAll(val, ids);
                  },
                },
              },
              option
            );
            return select;
          },
        },
        {
          align: "center",
          title: "单价",
          slot: "price",
        },
        {
          align: "center",
          title: "小计",
          slot: "total",
        },
        {
          align: "center",
          title: "操作",
          slot: "action",
        },
      ],
      columns3: [
        {
          type: "selection",
          width: 60,
        },
        {
          align: "center",
          title: "域名",
          key: "tradeName",
        },
        {
          align: "center",
          title: "年限",
          key: "count"
        },
        {
          align: "center",
          title: "单价",
          slot: "price",
        },
        {
          align: "center",
          title: "小计",
          slot: "total",
        },
        {
          align: "center",
          title: "操作",
          slot: "action",
        },
      ],
      // 模板分页
      templatePage: {
        page: 1,
        limit: 10,
        total: 0,
      },
      // 模板表格栅格
      templateColumns: [
        {
          type: "expand",
          width: "1",
          render: (h, { row }) => {
            return h(smTableExpand, {
              props: {
                info: row,
              },
            });
          },
        },
        {
          type: "selection",
          width: 60,
        },
        {
          key: "name",
        },
        {
          slot: "name",
        },
        {
          key: "email",
          width: "200px",
          render: (h, { row }) => {
            return h("div", row.email || "--");
          },
        },
        {
          key: "status",
          width: "140px",
          render: (h) => {
            return h("div", "已实名认证");
          },
        },
        {
          slot: "action",
          width: "160px",
        },
      ],
      // 模板数据
      templateData: [],
      // 域名注册loading
      registerLoading: false,
      // 注册域名数据
      registerList: [],
      // 注册域名数量
      registerCount: 0,
      // 域名续费loading
      renewLoading: false,
      // 续费域名数据
      renewList: [],
      // 续费域名数量
      renewCount: 0,
      // 转入域名数据
      transferList: [],
      // 转入域名数量
      transferCount: 0,
      // 域名转入loading
      transferLoading: false,
      // 总价格
      totalPrice: 0,
      // 支付类型
      orderStep: 2,
      // 支付加载状态
      payLoading: false,
      // 订单表格表头
      orderColumns: [
        {
          title: "订单编号",
          key: "orderNo",
          align: "center",
        },
        {
          title: "订单金额",
          key: "total",
          align: "center",
        },
        {
          title: "应付金额",
          key: "payAmount",
          align: "center",
        },
        {
          title: "下单时间",
          key: "createdTime",
          align: "center",
        },
        {
          title: "操作项",
          slot: "action",
          align: "center",
        },
      ],
      // 二维码链接
      wayPayCode: "",
      // 二维码支付弹窗
      wayModalShow: false,
      // 订单数据
      orderList: [],
      // 结果表格表头
      resColumns: [
        {
          title: "订单编号",
          key: "orderNo",
          align: "center",
        },
        {
          title: "订单金额",
          key: "total",
          align: "center",
        },
      ],
      // 结果数据
      resList: [],
      // 订单详情弹窗
      orderInfoModalShow: false,
      // 订单id
      orderId: "",
      // 在线支付加载状态
      orderLoading: false,
      // 域名注册协议
      domainNameRegisterRulesModelShow: false,
      domainNameRegisterRulesContent: "",
      domainNameRegisterRulesTitle: "",
      // 隐私声明
      privacyStatementRulesModelShow: false,
      privacyStatementRulesContent: "",
      privacyStatementRulesTitle: "",
    };
  },
  computed: {
    ...mapState(["balance", "token"]),
  },
  mounted() {
    if (!this.token) {
      this.$Message.warning("请登陆后操作！");
      this.$router.push("/login");
      return false;
    }
    if (this.$route.query.id) {
      this.orderId = this.$route.query.id;
      this.getDetail();
    }
    this.getAgreementList()
    this.req_getTemplates();
    this.req_getShoppingCart();
    this.ACT_USER_INFO();
  },
  beforeDestroy() {
    // 销毁定时器
    if (this.webSocket) {
      this.sendMessage("stop");
    }
    this.webSocketResetInterval && clearInterval(this.webSocketResetInterval);
    this.heartInterval && clearInterval(this.heartInterval);
  },
  methods: {
    ...mapActions(["ACT_USER_INFO"]),
    ...mapMutations(["MUT_BALANCE"]),
    // 协议
    domainNameRegisterRulesModel() {
      this.domainNameRegisterRulesModelShow = true;
      // if (!this.domainNameRegisterRulesContent) {
      //   this.domainNameRegisterRulesContent = domainNameRegisterRules.content;
      //   this.domainNameRegisterRulesTitle = domainNameRegisterRules.title;
      // }
    },
    privacyStatementRulesModel() {
      this.privacyStatementRulesModelShow = true;
      // if (!this.privacyStatementRulesContent) {
      //   this.privacyStatementRulesContent = privacyStatement.content;
      //   this.privacyStatementRulesTitle = privacyStatement.title;
      // }
    },
    getAgreementList(){
      agreementList([1,3]).then((res) => {
              const { code, data } = res;
              if(code === 200 && data.length>0){
                this.domainNameRegisterRulesContent = data[0].content
                this.domainNameRegisterRulesTitle = data[0].name
                this.privacyStatementRulesContent = data[1].content
                this.privacyStatementRulesTitle = data[1].name
              }
      });
    },
    // 获取详情
    async getDetail() {
      if (!this.orderId) return;
      this.step = 2;
      this.orderLoading = true;
      const res = await orderPayOrder({
        orderNo: this.orderId,
      });
      if (res.code === 200) {
        this.orderList = [
          {
            createdTime: res.data.createdTime,
            orderNo: res.data.id,
            payAmount: res.data.amount,
            total: res.data.total,
          },
        ];
        this.orderList = res.data.orderList;
      }
      this.orderLoading = false;
    },
    // 获取已实名认证模板
    async req_getTemplates() {
      const params = {
        page: this.templatePage.page,
        limit: this.templatePage.limit,
        audit: 2,
      };
      try {
        const { code, data, result } = await getTemplates(params);
        if (code === 200 && result) {
          const tData = [...data.list] || [];
          this.templateData = tData.map((o) => {
            return { ...o, _checked: false, _expanded: false };
          });
          this.templatePage.total = data.total;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取购物车
    async req_getShoppingCart() {
      try {
        this.renewLoading = true;
        this.registerLoading = true;
        this.transferLoading = true;
        const { code, data, result } = await getShoppingCart();
        this.renewLoading = false;
        this.registerLoading = false;
        this.transferLoading = false;
        if (code === 200 && result) {
          this.MUT_BALANCE(data.yue);
          data.shopList.forEach((o) => {
            if (o.type === 0) {
              this.registerList = o.voList.map((o1) => {
                // 注册价格
                const registerPrice =
                  o1.activityPrice != null ? o1.activityPrice : o1.price;
                if (o1.count === 1) {
                  this.totalPrice += registerPrice;
                } else {
                  // 超过一年使用续费价格
                  let renewPrice =
                    o1.renewActivityPrice != null
                      ? o1.renewActivityPrice
                      : o1.renewPrice;
                  this.totalPrice +=
                    registerPrice + renewPrice * (o1.count - 1);
                }
                return { ...o1, _checked: true };
              });
              console.log(this.registerList)
              this.registerCount = this.registerList.length;
            } else if (o.type === 1) {
              this.renewList = o.voList.map((o2) => {
                // 总价格
                this.totalPrice +=
                  (o2.activityPrice != null ? o2.activityPrice : o2.price) *
                  o2.count;
                return { ...o2, _checked: true };
              });
              this.renewCount = this.renewList.length;
            } else if (o.type === 2) {
              this.transferList = o.voList.map((o2) => {
                // 总价格
                this.totalPrice +=
                    (o2.activityPrice != null ? o2.activityPrice : o2.price) *
                    o2.count;
                return { ...o2, _checked: true };
              });
              this.transferCount = this.transferList.length;
            }
          });
        }
      } catch (error) {
        this.renewLoading = false;
        this.registerLoading = false;
        this.transferLoading = false;
      }
    },
    // 删除购物车
    del(type, data, index) {
      this.$Modal.confirm({
        title: "移除确认",
        content: "<p>确定要移除此域名吗？</p>",
        onOk: async () => {
          // 删除注册域名
          if (type === 0) {
            const res = await delectShopCart([data.id]);
            if (res.code === 200) {
              this.$Message.success("移除成功！");
              this.registerList.splice(index, 1);
              this.select();
            }
          } else if (type === 1) {
            const res = await delectShopCart([data.id]);
            if (res.code === 200) {
              this.$Message.success("移除成功！");
              this.renewList.splice(index, 1);
              this.select();
            }
          } else if (type === 2) {
            const res = await delectShopCart([data.id]);
            if (res.code === 200) {
              this.$Message.success("移除成功！");
              this.transferList.splice(index, 1);
              this.select();
            }
          }
          this.ACT_USER_INFO()
        },
      });
    },
    async calculateAll(count, ids) {
      const params = {
        cot: count,
        ids: ids,
      };
      const { code } = await orderCountEdit(params);
      if (code === 200) {
        this.calculate()
      }
    },
    // 计算价格
    calculate() {
      this.totalPrice = 0;
      if (this.$refs.registerTable) {
        this.$refs.registerTable.getSelection().forEach((o) => {
          // 注册价格
          const registerPrice =
            o.activityPrice != null ? o.activityPrice : o.price;
          if (o.count === 1) {
            this.totalPrice += registerPrice;
          } else {
            // 超过一年使用续费价格
            let renewPrice =
              o.renewActivityPrice != null
                ? o.renewActivityPrice
                : o.renewPrice;
            this.totalPrice += registerPrice + renewPrice * (o.count - 1);
          }
        });
      }
      if (this.$refs.renewTable) {
        this.$refs.renewTable.getSelection().forEach((o) => {
          this.totalPrice +=
            (o.activityPrice != null ? o.activityPrice : o.price) * o.count;
        });
      }
      if (this.$refs.transferTable) {
        this.$refs.transferTable.getSelection().forEach((o) => {
          this.totalPrice +=
              (o.activityPrice != null ? o.activityPrice : o.price) * o.count;
        });
      }
    },
    // 修改年限
    async itemYearChange(event, index, type) {
      try {
        const params = {
          cot: event,
          ids: [],
        };
        if (type === 0) {
          params.ids = [this.registerList[index].id];
        } else if (type === 1) {
          params.ids = [this.renewList[index].id];
        } else if (type === 2) {
          params.ids = [this.transferList[index].id];
        }
        const { code } = await orderCountEdit(params);
        if (code === 200) {
          if (type === 0) {
            const data = this.registerList[index];
            data.count = event;
          } else if (type === 1) {
            const data = this.renewList[index];
            data.count = event;
          } else if (type === 2) {
            const data = this.transferList[index];
            data.count = event;
          }
          this.calculate();
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 查看模板
    viewTemplate(data, index) {
      let tData = { ...data };
      tData._expanded = !tData._expanded;
      this.$set(this.templateData, index, { ...tData });
    },
    // 删除模板
    delTemplate(data, index) {
      this.$Modal.confirm({
        title: "删除确认",
        content: "<p>确定要删除此模板吗？</p>",
        onOk: async () => {
          // 删除注册域名
          const res = await delectTemplates(data.id);
          if (res.code === 200) {
            this.$Message.success("移除成功！");
            this.templateData.splice(index, 1);
          }
        },
      });
    },
    // 分页
    onChange(current) {
      this.templatePage.page = current;
      this.req_getTemplates();
    },
    // 分页页码
    onPageSizeChange(size) {
      this.templatePage.page = 1;
      this.templatePage.limit = size;
      this.req_getTemplates();
    },
    select() {
      if (this.$refs.registerTable) {
        this.registerCount = this.$refs.registerTable.getSelection().length;
      }
      if (this.$refs.renewTable) {
        this.renewCount = this.$refs.renewTable.getSelection().length;
      }
      if (this.$refs.transferTable) {
        this.transferCount = this.$refs.transferTable.getSelection().length;
      }
      this.calculate();
    },
    // 下单
    async event_buy() {
      if (!this.single) {
        this.$Message.warning("请阅读域见未来域名注册协议，域见未来隐私声明！");
        return false;
      }
      try {
        let registerSelect = [], renewSelect = [], transferSelect = [];
        if (this.$refs.registerTable) {
          registerSelect = this.$refs.registerTable.getSelection() || [];
        }
        if (this.$refs.renewTable) {
          renewSelect = this.$refs.renewTable.getSelection() || [];
        }
        if (this.$refs.transferTable) {
          transferSelect = this.$refs.transferTable.getSelection() || [];
        }
        const list = [...registerSelect, ...renewSelect, ...transferSelect];
        if (list.length === 0) {
          this.$Message.warning("请选择域名！");
          return false;
        }
        const templateTable = this.templateData.filter((o) => o._checked);
        if (registerSelect.length > 0 && !templateTable) {
          if (templateTable.length === 0) {
            this.$Message.warning("请选择模板！");
            return false;
          }
        }
        const params = {
          ids: list.map((o) => o.id),
        };
        if (registerSelect.length > 0) {
          params.temp = templateTable[0].id;
        }
        const { code, data } = await createOrder(params);
        if (code === 200) {
          this.MUT_BALANCE(data.account);
          this.orderList = data.orderList;
          this.step = 2;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 选择模板
    evt_select(selection, row) {
      this.templateData.forEach((o) => {
        o._checked = false;
        if (o.id === row.id) {
          o._checked = true;
        }
      });
    },
    // 选择支付方式
    payState(type) {
      this.orderStep = type;
    },
    async evt_pay() {
      if (this.orderStep === 2 && this.balance < this.orderList[0].payAmount) {
        this.$Message.warning("余额不足请前往充值！");
        return false;
      }
      try {
        this.payLoading = true;
        const params = {
          outTradeNo: this.orderList[0].orderNo,
          type: this.orderStep,
          source: 2,
        };
        const { code, data, message } = await pay(params);
        if (code === 200) {
          if (!this.webSocket) {
            this.startSocket();
          }
          if (this.orderStep === 0) {
            this.wayPayCode = data;
            this.wayModalShow = true;
          } else if (this.orderStep === 1) {
            this.wayPayCode = data;
            this.wayModalShow = true;
          }
          this.payLoading = false;
        } else {
          this.$Message.warning(message);
        }
      } catch (error) {
        this.payLoading = false;
      }
    },
    // webScoket发送消息
    sendMessage(txt) {
      this.webSocket.send(txt);
    },
    // webScoket异常重连
    resetConnect() {
      this.connectCount = this.connectCount || 0;
      if (!this.webSocketInterval) {
        this.webSocketResetInterval = setInterval(() => {
          this.connectCount += 1;
          if (this.connectCount <= 5) {
            this.startSocket();
            this.webSocketResetInterval &&
              clearInterval(this.webSocketResetInterval);
          }
        }, 1000);
      }
    },
    startSocket() {
      this.messageTotal = 0;
      this.webSocket = new WebSocket(
        `${WEBSOCKET_URL}/bjweb/webSocket/domainpay/${this.orderList[0].orderNo}/${this.token}`
      );
      // 接收消息事件
      this.webSocket.onmessage = (e) => {
        if (e.data === "open:suc") {
          this.sendMessage("start");
          this.heartInterval = setInterval(() => {
            if (this.messageTotal === 10) {
              this.sendMessage("heart");
              this.messageTotal = 0;
            }
            this.messageTotal += 1;
          }, 1000);
        }
        if (e.data.includes("msg:")) {
          const message = e.data.split("msg:")[1];
          this.messageTotal = 0;
          const info = JSON.parse(message);
          if (info != null && info.length != null && info.length > 0) {
            if (this.step != 3) {
              this.step = 3;
              this.wayModalShow = false;
            }
            this.resList = info;
          }
        }
        if (e.data.includes("rec:stop")) {
          this.webSocket.close();
          this.webSocket = "";
          this.heartInterval && clearInterval(this.heartInterval);
        }
      };
    },
    // 订单弹窗
    act_orderInfo(data) {
      this.orderInfoModalShow = true;
      this.orderId = data.orderNo;
    },
    // 去充值
    toRecharge() {
      this.$router.push("/my/finance/account/recharge");
    },
  },
};
</script>

<style lang="less" scoped>
.section {
  background-color: #f0f3f6;
  padding: 80px 0 80px;
  .cc-step {
    width: 1200px;
    margin: 0 auto;
  }
}
.step-warrp {
  .step-header-warrp {
    display: flex;
    justify-content: center;
    background-color: #e5e5e5;
    border-radius: 48px;
    padding: 20px 30px;
    .step-item {
      flex: 1;
      display: flex;
      align-items: center;
      &:first-child {
        &::before {
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
          display: none;
        }
      }
      &:nth-child(2) {
        &::before {
          display: none;
        }
      }
      &:last-child {
        flex: 0;
        &::before {
          display: none;
        }
        &::after {
          border-top-right-radius: 6px;
          border-bottom-right-radius: 6px;
          display: none;
        }
      }
      span {
        display: inline-block;
        width: 230px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        border-radius: 28px;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        background-color: #333333;
      }
      &::before,
      &::after {
        content: "";
        flex: 1;
        height: 19px;
        background-color: #d6d6d6;
        margin: 0 -2px;
      }
    }
    .step-item.active {
      span {
        color: #fff;
        background-color: #e8340b;
        border: none;
      }
      &::before,
      &::after {
        background-color: #e8340b;
      }
    }
  }
  .step-content {
    display: flex;
    .step-item-text {
      flex: 1;
      text-align: center;
      margin-top: 20px;
      color: #333333;
      font-weight: bold;
    }
    .step-item-text.active {
      color: #2d8cf0;
    }
  }
}
.c-o1 {
  color: #f9521f;
  font-weight: bold;
}
::v-deep .cc-table,
::v-deep .sm-table {
  .ivu-table-tip table td {
    line-height: 200px;
  }
  .ivu-table th {
    background-color: #e5e5e5;
  }
  .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #f9521f;
    background-color: #f9521f;
  }
  .ivu-checkbox-focus {
    box-shadow: none;
  }
  .ivu-table-row-hover td {
    background-color: #f7ebe9;
  }
}
::v-deep .sm-table {
  margin-top: 20px;
  .ivu-table-body {
    .ivu-table-tbody {
      .ivu-table-row {
        td:nth-child(1) {
          text-align: center;
          .ivu-checkbox-inner {
            border-radius: 50%;
          }
          .ivu-checkbox-focus {
            box-shadow: none;
          }
          .ivu-checkbox-checked .ivu-checkbox-inner {
            background-color: #fff;
            border-color: #ff5c35;
            &:after {
              border-color: #ff5c35;
            }
          }
        }
      }
    }
  }
}
.sm-info {
  padding: 40px 60px;
  background-color: #fff;
}
.transaction-tool {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  padding: 40px 60px;
  background-color: #fff;
}
.info-tool {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;
}
::v-deep .buy-btn {
  background-color: #ff5c35;
  color: #fff;
  margin-left: 40px;
  line-height: 40px;
  height: 40px;
  &:hover {
    border-color: #ff5c35;
  }
  &:focus {
    box-shadow: none;
  }
}
::v-deep .c-check {
  margin-right: 0;

  .ivu-checkbox {
    margin-right: 8px;
  }
  .ivu-checkbox-inner {
    border-radius: 50%;
  }
  .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff5c35;
    background-color: #ff5c35;
  }
  .ivu-checkbox-focus {
    box-shadow: none;
  }
  color: #999999;
}
.order-warp {
  .order-title {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-bottom: 30px;
  }
  margin-top: 70px;
  background-color: #fff;
  padding: 50px 60px;
  .order-tool {
    display: flex;
    align-items: center;
    .item-tool {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 200px;
      height: 90px;
      border: 1px solid #e8eaec;
      margin-right: 20px;
      border-radius: 4px;
      user-select: none;
      cursor: pointer;
      img {
        width: 34px;
        height: 30px;
        margin-right: 10px;
      }
    }
    .item-tool.active {
      border-color: #2d8cf0;
    }
  }
  .order-tool-title {
    padding: 20px 0;
    font-size: 18px;
    color: #333333;
  }
  .item-tool-info {
    flex-direction: column;
    padding: 0 20px;
    .tips {
      color: #999999;
      span {
        color: #2d8cf0;
      }
    }
  }
  ::v-deep .pay-btn {
    width: 110px;
    height: 46px;
    text-align: center;
    margin-top: 20px;
  }
  .pay-tips {
    margin-top: 30px;
    color: #3992e9;
  }
}
.order-result {
  background-color: #fff;
  margin-top: 70px;
  .order-success {
    padding: 80px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .order-success-icon {
      width: 107px;
      height: 95px;
      margin-bottom: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
::v-deep .template-table {
  .ivu-table-row {
    td:nth-child(1) {
      .ivu-table-cell-with-expand {
        width: 0;
      }
      .ivu-table-cell-expand {
        font-size: 0;
      }
    }
  }
}
.remove-btn ::v-deep {
  background-color: #f9521f;
  color: #fff;
  &:hover {
    border-color: #f9521f;
  }
  &:focus {
    box-shadow: none;
  }
}
.row {
  display: flex;
  align-items: center;
}
.table-title {
  color: #333333;
  font-size: 24px;
  line-height: 45px;
  margin-bottom: 20px;
}
</style>
